/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/media-has-caption */
import { useRef, useEffect, useState } from 'react'
import { createUseStyles } from 'react-jss'
import ally from 'ally.js'
import gsap from 'gsap'
import DelayLink from '@/components/DelayLink'
import style from './style'

const useStyles = createUseStyles(style)

const Popup = ({ closeLabel, link, image, open }) => {
  const classes = useStyles(style)
  const $root = useRef()
  const $content = useRef()
  const $close = useRef()
  const disableAllTabIndex = useRef(null)
  window.console.log('open ---->', open)
  const [isOpen, setIsOpen] = useState(open)

  /*------------------------------
  Close Popup
  ------------------------------*/
  const closeModal = () => {
    setIsOpen(false)
  }

  /*------------------------------
  HandleKeyboard
  ------------------------------*/
  const handleKeyboard = (e) => {
    // Esc = 27
    if (e.which === 27) {
      closeModal()
    }
  }

  /*------------------------------
  Events
  ------------------------------*/
  const events = () => {
    window.addEventListener('keydown', handleKeyboard)
  }

  /*------------------------------
  Destroy Events
  ------------------------------*/
  const destroyEvents = () => {
    window.removeEventListener('keydown', handleKeyboard)
  }

  /*------------------------------
  Apri Chiudi
  ------------------------------*/
  useEffect(() => {
    if (isOpen === true) {
      gsap.to($root.current, {
        duration: 0.5,
        autoAlpha: 1,
      })
      gsap.to($close.current, {
        duration: 0.5,
        autoAlpha: 1,
      })

      events()
    } else {
      gsap.to($root.current, {
        duration: 0.5,
        autoAlpha: 0,
        display: 'none',
      })
      gsap.to($root.current, {
        duration: 1,
        autoAlpha: 0,
      })

      destroyEvents()
    }
  }, [isOpen])

  /*------------------------------
  Enable keyboard navigation only in modal
  ------------------------------*/
  useEffect(() => {
    if (isOpen) {
      disableAllTabIndex.current = ally.maintain.disabled({
        filter: $root.current,
      })
    }
    if (!isOpen && disableAllTabIndex.current !== null) disableAllTabIndex.current.disengage()
  }, [isOpen])

  /*------------------------------
  Render
  ------------------------------*/
  return (
    <div
      className={classes.root}
      ref={$root}
      role="dialog"
      aria-modal="true"
    >
      <div className={classes.container}>
        <DelayLink
          to={link}
        >
          <div className={classes.image}><img src={image !== false ? image : ''} alt="" /></div>
        </DelayLink>
        <button
          className={classes.btnClose}
          onClick={closeModal}
          ref={$close}
          aria-label="close-modal"
          tabIndex={isOpen ? 0 : -1}
        >
          {closeLabel}
        </button>
      </div>
      <div onClick={closeModal} className={classes.background} />
    </div>
  )
}

Popup.defaultProps = {
  modalData: {},
}

export default Popup
